import { DEFAULT_ROUTES } from "./routes";

export const HEADER_ITEMS = [
  {
    title: "Dashboard",
    link: DEFAULT_ROUTES.INDEX,
    submenu: [],
  },
  {
    title: "Private Rooms",
    link: "",
    submenu: [
      {
        title: "Listagem de bokão",
        link: DEFAULT_ROUTES.BOOKINGS,
      },
    ],
  },
  {
    title: "Visit Schedules",
    link: DEFAULT_ROUTES.INDEX,
    submenu: [],
  },
];
